import { render, staticRenderFns } from "./Filhos.vue?vue&type=template&id=d70f8b2c&"
import script from "./Filhos.vue?vue&type=script&lang=js&"
export * from "./Filhos.vue?vue&type=script&lang=js&"
import style0 from "./Filhos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports